import { render, staticRenderFns } from "./announcement-dialog.vue?vue&type=template&id=29afa0d2&scoped=true"
import script from "./announcement-dialog.vue?vue&type=script&lang=js"
export * from "./announcement-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29afa0d2",
  null
  
)

export default component.exports